import Api from '../../utils/api'

import { ILocationFolder } from './types'

export const compareByName = (a: ILocationFolder, b: ILocationFolder) => a.name.localeCompare(b.name, undefined, { numeric: true, sensitivity: 'base' })

// Folders directly under a parent in the tree (the roots for null), sorted by name
export const getChildren = (folderTree: IFolderTreeResponse | null, parentId: number | null): ILocationFolder[] => {
  if (!folderTree) return []
  const childIds = parentId === null ? folderTree.roots : (folderTree.tree[parentId]?.children ?? [])
  return childIds
    .filter((id) => folderTree.tree[id])
    .map((id) => ({ id, name: folderTree.tree[id].name }))
    .sort(compareByName)
}

// Returns the participant followed by its child participants (sorted by name), or null if the folder isn't a participant
export const fetchParticipantFolders = async (folderId: number): Promise<ILocationFolder[] | null> => {
  const folderRes = await Api.get(`/api/folders/${folderId}`)
  if (!folderRes.ok || (folderRes.body as IFolderType).type !== 'Participant') return null

  const childrenRes = await Api.get(`/api/v2/protect/folders/${folderId}/participant-children`)
  if (!childrenRes.ok) return null

  const { participants } = childrenRes.body as {
    participants: { folder: { id: number; name: string }; hasAlerts: boolean; isActivated: boolean; isOnboarded: boolean }[]
  }
  const [parent, ...children] = participants.map(({ folder, hasAlerts, isActivated, isOnboarded }) => ({
    id: folder.id,
    name: folder.name,
    hasAlerts,
    isIncomplete: !isActivated || !isOnboarded,
  }))
  return [parent, ...children.sort(compareByName)]
}
